import { createMutation } from '@tanstack/svelte-query'
import queryClient from '../../../constants/query-client'
import { getSceneLights, isSceneLights } from '../../../helpers/lights'
import { getProject } from '../../../api/projects'
import { get } from 'svelte/store'
import { storeScene } from '../../../stores/scene'
import { preferredPrinter } from '../../../stores/preferred-printer'
import { ThreeItemKeys } from '../../../constants/three'
import { focusOnSceneContent } from '../../../stores/camera'
import ScenePersistence from '../../../services/scene-persistence'

const useSceneQueries = () => {
  const loadProjectSceneMutation = createMutation(() => ({
    mutationKey: ['loadProjectScene'],
    mutationFn: async (projectId: string) => {
      const projectData = await getProject(projectId)

      if (projectData.data?.compressedThreeJsonUrl) {
        const newScene = await ScenePersistence.onLoad(projectData.data?.compressedThreeJsonUrl)

        const scene = get(storeScene)
        scene?.clear()
        for (const child of newScene.children) {
          scene?.add(child.clone())
        }
        if (scene) Object.assign(scene.userData, newScene.userData)
      }
      else {
        const scene = get(storeScene)
        const hasLights = scene?.children.some(isSceneLights) ?? false
        if (!hasLights) {
          const lights = getSceneLights()
          scene?.add(lights)
        }
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['canvas'] })
      preferredPrinter.set(get(storeScene)?.userData[ThreeItemKeys.PREFERRED_PRINTER] ?? null)
      const scene = get(storeScene)
      if (scene) focusOnSceneContent(scene)
    },
  }), () => queryClient)

  return {
    loadProjectSceneMutation,
  }
}

export default useSceneQueries
